$(document).ready(function(){
  // HandleBar 
  var source = $('#collectionraw').html();
  var $collectionContainer = $('#collectionContainer');
  var $gridbanner = $('.additional-banner-grid');
  
  function CollectionHandleBar(source) {
      var template = Handlebars.compile(source);

      Handlebars.registerHelper("ifMobile", function(options){
        if ( $(window).width() < 768  ) {
          return options.fn(this);
        } else {
          return options.inverse(this);
        }
      });
    
      Handlebars.registerHelper("ifLarge", function(options){
        if ( $(window).width() > 1919   ) {
          return options.fn(this);
        } else {
          return options.inverse(this);
        }
      });
		
      return template;
  }

  // Init
  var template = CollectionHandleBar(source);
  $collectionContainer.html(template);
  $collectionContainer.append($gridbanner);
  ajaxCart.init();
  
  if ( $gridbanner ) {
  	$gridbanner.insertBefore( $gridbanner.prev() );
  }
  
  function discount() {
    $('.discount-off').each(function(index){
      var $PP = $(this).data('pp');
      var $CC = $(this).data('cc');
      var $frac =  $CC / $PP;
      var $perc = ($frac * 100) - 100;
      var pos = parseInt(Math.round($perc) );
      $(this).html(Math.abs(pos)+'% OFF');
    });
  }
  discount();
  function buckscssconverter() {
    var buckconverter = $('.product-list').last().find('.money').html();
    var buckcurrency = buckconverter.replace(/[\d\., ]/g, '');

    $('.money').each(function() {
      var amount_strip = $(this).html();
      amount_strip = amount_strip.replace(/[^\d.+-]|\.(?=.*\.)/g, '');

    });
  }

  
  // Load More
  function CollectionAjaxLoadmore() {
    var nexturl = $collectionContainer.find('#next-url');
    var params = {
      type: 'GET',
      url: nexturl.val(),
      success: function(item) {
        nexturl.remove();
        
        var html = $(item).find('#collectionraw').html();
        var template = CollectionHandleBar(html);
        $collectionContainer.append( template );

        discount();
        buckscssconverter();
        ajaxCart.init();
        
        /*
        if ( banner ) {
        	banner.insertBefore('.scroll-tag');
        } */
      },
      error: function(XMLHttpRequest, textStatus) {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    };
    $.ajax(params);
  };

  function CollectionFillerSize() {
    if ( $('#collectionContainer')[0] ) {
      var he = $('#collectionContainer .product-list .product-summary').last().outerHeight();
    } else {
      var he = $('.lb-product-content .product-list .product-summary').last().outerHeight();
    }
    $('#collectionblankfiller .list div p').each(function(){
      $(this).height(he);
    });
  }
	
  //Fade Effects
  var timeoutdu = 400;
  $(document).on('DOMNodeInserted', function (e) {
    if ( $(e.target).hasClass('product-list') ) {
      $(e.target).addClass('fade-out');
      timeoutdu += 200;
      setTimeout(function(){
      	$(e.target).addClass('fade-out-in');
      },timeoutdu);
    }
    //Reset
    if ( $(e.target).hasClass('scroll-tag') ) {
      timeoutdu = 400;
      return;
    }

    //Collection Filler Size Correction
    CollectionFillerSize();
  });

  $(window).resize(function(){
    CollectionFillerSize();
  });


  
  // Scroll Function
  $(window).scroll(function(){
    
    if ( $('#next-url')[0] ) {
      
      var windowST = $(this).scrollTop();
      var windowH = $(this).height();
      var windowX = windowST + windowH;
      var $scrollTag   = $('.scroll-tag');
      var scrollTagST = $scrollTag.offset();
	
      if ( $scrollTag ) {
        if ( scrollTagST ) {
      		var scrollTagST = scrollTagST.top;
        }
      } else {
      	return;
      }
      
      
      var scrollTagSH = $gridbanner.height();
      
      if ( $(this).width() > 767 ) {
      	var scrollTagX  = scrollTagST - (scrollTagSH + 1000);

      } else {
      	var scrollTagX  = scrollTagST - 300;
      }
       
      

      if ( windowX > scrollTagX ) {
        
        if ( $scrollTag.hasClass('product-loaded') ) {} else {
          CollectionAjaxLoadmore();
          
          	$scrollTag.removeClass('scroll-tag');
          
          	$scrollTag.addClass('loading-tag');
          
          	$(document).on('DOMNodeInserted', function (e) {
                if ( $(e.target).hasClass('product-list') ) {
                  $scrollTag.removeClass('loading-tag');
                }
          	});
        } 
      }
    }
    
  });
});



 jQuery(document).ready(function($){
    var gswiper = new Swiper('#c-banner-mob .swiper-container', {
      pagination: '.swiper-pagination'
    });
    
    gswiper.on('slideNextTransitionStart', function () {
      $('#c-banner-mob .swiper-container').addClass('show-prev');
        $('#c-banner-mob .swiper-container').removeClass('show-next');
  });
    
     gswiper.on('slidePrevTransitionStart', function () {
      $('#c-banner-mob .swiper-container').addClass('show-next');
        $('#c-banner-mob .swiper-container').removeClass('show-prev');
  });
    
    $('.anchor a').click(function(){
      var parent = $(this).parents('#c-banner');
      var par_parent = parent.parent();
      var next = par_parent.next();
      $('html, body').animate({
        scrollTop : $(next).offset().top - 80
      },1000)
    });
   
   
   
    $('.anchor').click(function(){
     
      var parent = $(this).parent('#c-banner');
      var par_parent = parent.parents();
      var next = par_parent.next();
      $('html, body').animate({
        scrollTop : $(next).offset().top - 78
      },1000)
    });

});


$(document).ready(function() {
  $('.right-filter h3').each(function(){
    $(this).on('click', function(){
      var $data = $(this).attr('data-toggle');
      $('#'+$data).stop().slideToggle('slow');
      $(this).toggleClass('current', 'slow');
      $(this).children('.toggle-switch').toggleClass('minus', 'slow');
      $('#'+$data).toggleClass('current', 'slow');
    });
  });
  $('.sorts-new').on('click', function(){

    $(this).toggleClass('active');
    $(this).removeClass('not_active');
    $('.opacity-1').not(this).addClass('not_active');

    $('#collection, .collection-xs').slideUp().removeClass('current');
    $('.band-new').removeClass('active');
    $('#band, .band').slideUp().removeClass('current');
    $('.band-new .toggle-switch').removeClass('minus');
    $('.dial-new').removeClass('active');
    $('#dial, .dial').slideUp().removeClass('current');
    $('.dial-new .toggle-switch').removeClass('minus');

  });
  $('.collection-new').on('click', function(){
    $(this).toggleClass('active');
    $(this).removeClass('not_active');
    $('.opacity-1').not(this).addClass('not_active');
    $('.band-new').removeClass('active');
    $('#band, .band').slideUp().removeClass('current');
    $('.band-new .toggle-switch').removeClass('minus');
    $('#dial, .dial').slideUp().removeClass('current');
    $('.dial-new').removeClass('active');
    $('.dial-new .toggle-switch').removeClass('minus');
    $('.sorting').slideUp().removeClass('current');
    $('.sorts-new .toggle-switch').removeClass('minus');

  });
  $('.band-new').on('click', function(){
    $(this).toggleClass('active');
    $(this).removeClass('not_active');
    $('.opacity-1').not(this).addClass('not_active');

    $('#collection, .collection-xs').slideUp().removeClass('current');
    $('.collection-new .toggle-switch').removeClass('minus');
    $('.collection-new').removeClass('active');
    $('#dial, .dial').slideUp().removeClass('current');
    $('.dial-new .toggle-switch').removeClass('minus');
    $('.dial-new').removeClass('active');
    $('.sorting').slideUp().removeClass('current');
    $('.sorts-new .toggle-switch').removeClass('minus');

  });
  $('.dial-new').on('click', function(){
    $(this).toggleClass('active');
    $(this).removeClass('not_active');
    $('.opacity-1').not(this).addClass('not_active');
    //$('.opacity-1').not(this).addClass('not_active');
    $('.collection-new').removeClass('active');
    $('#collection, .collection-xs').slideUp().removeClass('current');
    $('.collection-new .toggle-switch').removeClass('minus');
    $('#band, .band').slideUp().removeClass('current');
    $('.band-new .toggle-switch').removeClass('minus');
    $('.band-new').removeClass('active');
    $('.sorting').slideUp().removeClass('current');
    $('.sorts-new .toggle-switch').removeClass('minus');
  });

  $(".opacity-1").click(function(){
    if ( $('.Collection-filter').hasClass("current") ) {
      console.log("i have the protected class");
    } else {
      $('.opacity-1').removeClass("not_active");
    }
  });

  $('.sorting-xs').on('click', function(){
    $('#sort-filter .hide-toggle').slideUp();
    $('#sort-filter h3 .toggle-switch').removeClass('minus');
    $('#sort-filter .opacity-1').removeClass("not_active");
  });
  $('#sorts').on('click', function(){
    $('#filter .filter-sort').slideUp();
    $('#filter h3 .toggle-switch').removeClass('minus');
  });

  $('.filter-is-hover').hover(function(){
    if ( $(this).hasClass('isnotactive') ) {} else {
      $(this).removeClass('isnothover');
      $('.sort-is-hover').toggleClass('isnothover');
    }
  });

  $('.sort-is-hover').hover(function(){
    if ( $(this).hasClass('isnotactive') ) {} else {
      $(this).removeClass('isnothover');
      $('.filter-is-hover').toggleClass('isnothover');
    }
  });


  $(".right-menu .filters h3").hover(
    function(e){ 
      $(this).addClass('force-hover');
      $('.right-menu .filters h3, .opacity-1').not(this).addClass('not-hover');
    },
    function(e){ 
      $(this).removeClass('force-hover');
      $('.right-menu .filters h3, .opacity-1').not(this).removeClass('not-hover');
    }
  );


  /* FROM CHILD */

  $("#collection .coll-filter").hover(
    function(e){ 
      $(this).addClass('force-hover');
      $('#collection .coll-filter').not(this).addClass('not-hover');
    },
    function(e){ 
      $(this).removeClass('force-hover');
      $('#collection .coll-filter').not(this).removeClass('not-hover');
    }
  );
  $("#band .coll-filter").hover(
    function(e){ 
      $(this).addClass('force-hover');
      $('#band .coll-filter').not(this).addClass('not-hover');
    },
    function(e){ 
      $(this).removeClass('force-hover');
      $('#band .coll-filter').not(this).removeClass('not-hover');
    }
  );
  $("#dial .coll-filter").hover(
    function(e){ 
      $(this).addClass('force-hover');
      $('#dial .coll-filter').not(this).addClass('not-hover');
    },
    function(e){ 
      $(this).removeClass('force-hover');
      $('#dial .coll-filter').not(this).removeClass('not-hover');
    }
  );

  $('.filter-is-hover').click(function(){
    $(this).removeClass('isnotactive');
    $(this).removeClass('isnothover');
    $('.sort-is-hover').toggleClass('isnotactive');
    $('#sorting').slideUp('slow');
    $('.sort-is-hover').find('.toggle-switch').removeClass('minus');
  });

  $('.sort-is-hover').click(function(){
    $(this).removeClass('isnotactive');
    $(this).removeClass('isnothover');
    $('.filter-is-hover').toggleClass('isnotactive');
    $('#filter').slideUp('slow');
    $('.filter-is-hover').find('.toggle-switch').removeClass('minus');
  });
});
/* Mobile */
$(document).ready(function() {
  $('.right-filter .filter-row-xs h3').each(function(){
    $(this).on('click', function(){
      var $data = $(this).attr('data-toggle-xs');
      console.log($data);
      $('.'+$data).slideToggle('slow');
      $(this).toggleClass('current', 'slow');
      $(this).children('.toggle-switch').toggleClass('minus-xs', 'slow');
      $('.'+$data).children('h3').toggleClass('current', 'slow');
      $('.'+$data).toggleClass('current', 'slow');
    });
  });
  /* Child HOVER */
  $('.right-filter .filter-row-xs h3').hover(function(){
    $('.right-filter .filter-row-xs h3').removeClass('current');
    $(this).toggleClass('force-hover', 'slow');
  });
  /* CHILD TOGGLE */
  $('.filter-row-xs .left-menu.xs').click(function(){
    $('#sort-filter').slideUp('slow');
    $('.right-menu h3').find('.toggle-switch').removeClass('minus');
    $('#sort-filter .opacity-1').removeClass("not_active");
  });
  $('.filter-row-xs .right-menu.xs').click(function(){
    $('.filter-row-xs .left-menu .right-filter-menu').slideUp('slow');
    $('.left-menu .page-title').find('.toggle-switch').removeClass('minus');
  });
  $('#sort-filter .opacity-1').click(function(){
    if ( $('#sort-filter .hide-toggle').hasClass("current") ) {
      console.log("i have the protected class");
    } else {
      $('#sort-filter .opacity-1').removeClass("not_active");
    }
  });
});